
<form [formGroup]="phunkBox" (ngSubmit)="onSubmit($event)">
  <div class="input-wrapper">
    <input
      #searchInput
      type="text"
      class="shared-input"
      [placeholder]="phunkBoxError ? 'Bad input. Try again' : 'Search: 0x, ENS or Token ID'"
      formControlName="addressInput"
      [class.error]="phunkBoxError"
      [class.disabled]="phunkBoxLoading"
      (focus)="onFocus($event)"
      (blur)="onBlur($event)"
      autocapitalize="off"
      autocorrect="off"
      autocomplete="off"
      spellcheck="false"
    />
    @if (phunkBox.dirty || phunkBox.touched && phunkBox.value?.addressInput?.length) {
      <button class="clear" type="reset" (click)="clearInput()">x</button>
    }
    @if (searchHistoryActive) {

      @if (searchHistory.length > 0) {
        <div class="dropdown shared-dropdown-bg">
          <div class="dropdown-header">
            <div>
              <h5>Search History</h5>
              @if (searchHistory.length > 1) {
                <button type="button" (click)="clearSearchHistory()">clear</button>
              }
            </div>

            <button type="button" class="close" (click)="unfocusInput()">close</button>
          </div>
          @for (item of searchHistory; track item.value) {
            <div class="item">
              <div class="value" (click)="selectHistoryItem(item)">{{ item.value }}</div>
              <div class="remove" (click)="removeHistoryItem(item)">x</div>
            </div>
          }
        </div>
      }
    }    
  </div>

  @if (phunkBoxLoading) {
    <button class="loader">
      <img [src]="'/assets/loader-' + theme + '.gif'" width="20" height="20" />
    </button>
  } @else {
    <button i18n class="submit" type="submit">Go</button>
  }
</form>

